<template>
  <transition name="fade-in" appear>
    <div
      v-hover-scale-mouse
      data-apollo-hover
      class="hamburger"
      @mouseenter="hoverAnimation(false)"
      @mouseleave="hoverAnimation(true)">
      <svg
        width="100%"
        height="100%"
        viewBox="28 0 38 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <!-- eslint-disable -->
        <g class="path">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16 1L51 0.999997L16 1Z" fill="white"/>
          <path d="M16 1L51 0.999997" stroke="#F4E5E7" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M94 1H59H94Z" fill="white"/>
          <path d="M94 1H59" stroke="#F4E5E7" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"/>
        </g>
        <g class="path">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M36 12L1 12L36 12Z" fill="white"/>
          <path d="M36 12L1 12" stroke="#F4E5E7" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M44 12H79H44Z" fill="white"/>
          <path d="M44 12H79" stroke="#F4E5E7" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"/>
        </g>
        <!-- eslint-enable -->
      </svg>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import anime from 'animejs';

export default {
  name: 'AppHamburger',
  data() {
    return {
      isAnimating: false,
      animationDuration: 800,
    };
  },
  computed: {
    ...mapState(['menuIsOpen']),
  },
  watch: {
    menuIsOpen() {
      this.clickAnimation(!this.menuIsOpen);
    },
  },
  methods: {
    hoverAnimation(reverse = false) {
      if (!this.menuIsOpen && !this.isAnimating) {
        anime({
          targets: this.$el.querySelectorAll('.path'),
          translateX(el, i) {
            if (reverse) return 0;
            return i % 2 === 0 ? '-15' : '15';
          },
          easing: 'easeInOutSine',
          duration: this.animationDuration / 2,
        });
      }
    },
    clickAnimation(reverse = false) {
      this.isAnimating = true;

      anime({
        targets: this.$el.querySelectorAll('.path'),
        translateX(el, i) {
          if (reverse) return 0;
          return i % 2 === 0 ? -29 : 29;
        },
        translateY(el, i) {
          if (reverse) return 0;
          return i % 2 === 0 ? 5.25 : -5.25;
        },
        opacity(el, i) {
          if (reverse) return 1;
          return i % 2 === 0 ? 0 : 1;
        },
        easing: 'easeInOutSine',
        duration: this.animationDuration,
        complete: () => {
          this.isAnimating = false;
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.hamburger {
  box-sizing: content-box;
  padding: 1rem;
  width: 2vw;
  min-width: 38px;
cursor: pointer;

  transform: translateY(-50%) translateX(1rem);

  & ::v-deep path {
    stroke: #ffffff;
    opacity: 0.7;
  }
}

/* animation */
.fade-in {
  &-enter-active {
    transition: opacity 2s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  &-enter {
    opacity: 0;
  }
}
</style>
